import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function GettingStartedSteps() {
  return <section className="w-full bg-[#FAF8F4] py-20 md:py-32 overflow-hidden" data-id="element-1102">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-1103">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-1104">
          <span className="block text-xs font-semibold tracking-[5px] uppercase text-neutral-400 mb-5 md:mb-6" data-id="element-1105">
            Plug-and-play
          </span>
          <h2 className="text-4xl md:text-6xl font-title font-medium text-[#2B211A] tracking-tight leading-[1.1] mb-6" data-id="element-1106">
            Up and running in 2 minutes
          </h2>
          <p className="text-lg md:text-xl text-neutral-500 leading-relaxed" data-id="element-1107">
            No setup project. No IT ticket. No training videos.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-16 md:mb-20" data-id="element-1108">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} className="flex flex-col bg-white rounded-[2rem] border border-neutral-200/70 shadow-sm overflow-hidden" data-id="element-1109">
            {/* Visual */}
            <div className="relative h-64 bg-[#1A1410] p-8 flex flex-col items-center justify-center gap-4 overflow-hidden" data-id="element-1110">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(234,88,12,0.15),transparent_50%)]" data-id="element-1111" />

              {/* Slack Button Mockup */}
              <div className="relative z-10 w-full max-w-[240px] bg-white rounded-2xl p-3 flex items-center justify-between shadow-xl" data-id="element-1112">
                <div className="flex items-center gap-3" data-id="element-1113">
                  <div className="w-8 h-8 rounded-lg bg-[#FAF8F4] flex items-center justify-center shrink-0" data-id="element-1114">
                    <img src="https://cdn.simpleicons.org/slack" alt="Slack" className="w-5 h-5" data-id="element-1115" />
                  </div>
                  <div className="flex flex-col" data-id="element-1116">
                    <span className="text-sm font-semibold text-[#2B211A]" data-id="element-1117">
                      Add to Slack
                    </span>
                    <span className="text-[10px] text-neutral-400" data-id="element-1118">
                      OAuth · live in minutes
                    </span>
                  </div>
                </div>
                <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-1119">
                  <Check size={12} strokeWidth={3} data-id="element-1120" />
                </div>
              </div>

              <span className="relative z-10 text-white/40 text-sm font-medium" data-id="element-1121">
                or
              </span>

              {/* Teams Button Mockup */}
              <div className="relative z-10 w-full max-w-[240px] bg-white rounded-2xl p-3 flex items-center justify-between shadow-xl opacity-90" data-id="element-1122">
                <div className="flex items-center gap-3" data-id="element-1123">
                  <div className="w-8 h-8 rounded-lg bg-[#FAF8F4] flex items-center justify-center shrink-0" data-id="element-1124">
                    <img src="https://cdn.simpleicons.org/microsoftteams" alt="Teams" className="w-5 h-5" data-id="element-1125" />
                  </div>
                  <div className="flex flex-col" data-id="element-1126">
                    <span className="text-sm font-semibold text-[#2B211A]" data-id="element-1127">
                      Add to MS Teams
                    </span>
                    <span className="text-[10px] text-neutral-400" data-id="element-1128">
                      OAuth · live in minutes
                    </span>
                  </div>
                </div>
                <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-1129">
                  <Check size={12} strokeWidth={3} data-id="element-1130" />
                </div>
              </div>
            </div>
            {/* Text */}
            <div className="p-8 md:p-10 flex-1 flex flex-col" data-id="element-1131">
              <h3 className="flex items-center gap-3 text-xl font-title font-semibold text-[#2B211A] mb-4" data-id="element-1132">
                <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#EA580C]/10 text-[#EA580C] text-sm font-bold shrink-0" data-id="element-1133">
                  1
                </span>
                Add to Slack or Teams
              </h3>
              <p className="text-neutral-500 leading-relaxed text-sm md:text-base" data-id="element-1134">
                Install Giga from the app directory. It shows up like any new
                teammate, ready to talk.
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex flex-col bg-white rounded-[2rem] border border-neutral-200/70 shadow-sm overflow-hidden" data-id="element-1135">
            {/* Visual */}
            <div className="relative h-64 bg-[#1A1410] flex items-center justify-center overflow-hidden" data-id="element-1136">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(234,88,12,0.1),transparent_70%)]" data-id="element-1137" />

              {/* Center Logo */}
              <div className="relative z-20 w-16 h-16 rounded-2xl bg-[#EA580C] flex items-center justify-center shadow-[0_0_40px_rgba(234,88,12,0.4)]" data-id="element-1138">
                <img src="https://cdn.magicpatterns.com/uploads/bxQBDjkPJfWx4r7DHyApcd/Vector.png" alt="Giga" className="w-8 h-8 object-contain [filter:brightness(0)_invert(1)]" data-id="element-1139" />
              </div>

              {/* Orbiting Icons */}
              <div className="absolute inset-0 z-10 flex items-center justify-center" data-id="element-1140">
                <div className="absolute w-[180px] h-[180px] border border-white/10 rounded-full" data-id="element-1141" />

                <div className="absolute top-[15%] left-[20%] w-10 h-10 rounded-xl bg-white flex items-center justify-center shadow-lg rotate-[-10deg]" data-id="element-1142">
                  <img src="https://cdn.simpleicons.org/hubspot" alt="HubSpot" className="w-5 h-5" data-id="element-1143" />
                </div>
                <div className="absolute bottom-[20%] left-[15%] w-10 h-10 rounded-xl bg-white flex items-center justify-center shadow-lg rotate-[5deg]" data-id="element-1144">
                  <img src="https://cdn.simpleicons.org/notion" alt="Notion" className="w-5 h-5" data-id="element-1145" />
                </div>
                <div className="absolute top-[20%] right-[15%] w-10 h-10 rounded-xl bg-white flex items-center justify-center shadow-lg rotate-[15deg]" data-id="element-1146">
                  <img src="https://cdn.simpleicons.org/salesforce" alt="Salesforce" className="w-5 h-5" data-id="element-1147" />
                </div>
                <div className="absolute bottom-[15%] right-[20%] w-10 h-10 rounded-xl bg-white flex items-center justify-center shadow-lg rotate-[-5deg]" data-id="element-1148">
                  <img src="https://cdn.simpleicons.org/linear" alt="Linear" className="w-5 h-5" data-id="element-1149" />
                </div>
              </div>
            </div>
            {/* Text */}
            <div className="p-8 md:p-10 flex-1 flex flex-col" data-id="element-1150">
              <h3 className="flex items-center gap-3 text-xl font-title font-semibold text-[#2B211A] mb-4" data-id="element-1151">
                <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#EA580C]/10 text-[#EA580C] text-sm font-bold shrink-0" data-id="element-1152">
                  2
                </span>
                Connect your tools
              </h3>
              <p className="text-neutral-500 leading-relaxed text-sm md:text-base" data-id="element-1153">
                Link your CRM, Drive, calendar, and analytics. Each connection
                lets Giga act, not just read.
              </p>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col bg-white rounded-[2rem] border border-neutral-200/70 shadow-sm overflow-hidden" data-id="element-1154">
            {/* Visual */}
            <div className="relative h-64 bg-[#1A1410] flex items-end justify-center px-6 pt-8 overflow-hidden" data-id="element-1155">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(234,88,12,0.15),transparent_60%)]" data-id="element-1156" />

              {/* Slack Message Mockup */}
              <div className="relative z-10 w-full max-w-[280px] bg-white rounded-t-2xl p-5 shadow-2xl translate-y-2" data-id="element-1157">
                <div className="flex items-start gap-3" data-id="element-1158">
                  <div className="w-8 h-8 rounded-lg bg-[#EA580C] flex items-center justify-center shrink-0 mt-1" data-id="element-1159">
                    <img src="https://cdn.magicpatterns.com/uploads/bxQBDjkPJfWx4r7DHyApcd/Vector.png" alt="Giga" className="w-4 h-4 object-contain [filter:brightness(0)_invert(1)]" data-id="element-1160" />
                  </div>
                  <div className="flex flex-col gap-1.5 w-full" data-id="element-1161">
                    <div className="flex items-baseline gap-2" data-id="element-1162">
                      <span className="font-bold text-[#2B211A] text-sm" data-id="element-1163">
                        Giga
                      </span>
                      <span className="text-[10px] font-medium px-1.5 py-0.5 rounded bg-neutral-100 text-neutral-500" data-id="element-1164">
                        APP
                      </span>
                      <span className="text-[10px] text-neutral-400" data-id="element-1165">
                        7:00 AM
                      </span>
                    </div>
                    <p className="text-xs text-[#2B211A] leading-relaxed" data-id="element-1166">
                      Done. Compared 7 suppliers, found one with &gt;40%
                      savings.
                    </p>
                    <span className="text-[10px] text-blue-600 hover:underline cursor-pointer" data-id="element-1167">
                      acme-analysis.giga.space
                    </span>

                    {/* Mini Chart */}
                    <div className="mt-2 w-full bg-[#FAF8F4] border border-neutral-100 rounded-xl p-3" data-id="element-1168">
                      <div className="flex justify-between items-end h-10 gap-1.5" data-id="element-1169">
                        {[40, 70, 45, 90, 60, 30, 80].map((h, i) => <div key={i} className="w-full bg-blue-500 rounded-t-sm" style={{
                        height: `${h}%`
                      }} data-id="element-1170" />)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Text */}
            <div className="p-8 md:p-10 flex-1 flex flex-col" data-id="element-1171">
              <h3 className="flex items-center gap-3 text-xl font-title font-semibold text-[#2B211A] mb-4" data-id="element-1172">
                <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#EA580C]/10 text-[#EA580C] text-sm font-bold shrink-0" data-id="element-1173">
                  3
                </span>
                Assign your first job
              </h3>
              <p className="text-neutral-500 leading-relaxed text-sm md:text-base" data-id="element-1174">
                Give Giga a task that eats your week. It does it, then runs it
                on a schedule if you want.
              </p>
            </div>
          </motion.div>
        </div>

        {/* CTA */}
        <div className="flex justify-center" data-id="element-1175">
          <a href="/signup" className="inline-flex items-center justify-center rounded-full bg-[#EA580C] px-8 py-4 text-base font-bold text-white shadow-lg shadow-[#EA580C]/20 transition-all duration-300 hover:bg-[#d24e09] hover:scale-105" data-id="element-1176">
            Get started for free
          </a>
        </div>
      </div>
    </section>;
}